import en from './enMain';
import nl from './nlMain';

const languages = { en, nl } as any;

export function doesTranslateKeyExistLang(currentLanguageCode: string, key: string): boolean {
    const parts = key.split('.');
    const language = languages[currentLanguageCode];

    let temp = language;
    for (const part of parts) {
        temp = temp[part];
        if (!temp) {
            return false;
        }
    }

    return true;
}

export function translateKeyLang(
    currentLanguageCode: string,
    key: string,
    variable0?: string,
    variable1?: string,
    variable2?: string
): string {
    const parts = key.split('.');
    const language = languages[currentLanguageCode];

    let result = language;
    for (const part of parts) {
        result = result[part];
        if (!result) {
            return '*** Translate error: cannot find key "' + key + '" for ' + currentLanguageCode + ' ***';
        }
    }

    if (variable0 !== undefined) {
        result = result.replace(/\{0\}/g, variable0);
    }
    if (variable1 !== undefined) {
        result = result.replace(/\{1\}/g, variable1);
    }
    if (variable2 !== undefined) {
        result = result.replace(/\{2\}/g, variable2);
    }

    return result;
}
